module.exports = __webpack_public_path__ + "img/ColumnasArchivos.460e94f3.png";